module.exports = __webpack_public_path__ + "media/images/jumping/promo-beneficios-section-568e7b0450b314ada18f203f0ae2312f.jpg";